var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCopiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1306_865",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1306_865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.55 14.1252L8.2004 11.7498C8.0336 11.5998 7.8336 11.5248 7.6004 11.5248C7.3668 11.5248 7.1584 11.6082 6.9752 11.775C6.8084 11.9582 6.725 12.1666 6.725 12.4002C6.725 12.6334 6.8084 12.8334 6.9752 13.0002L9.9752 15.975C10.1252 16.1418 10.3168 16.2252 10.55 16.2252C10.7836 16.2252 10.9754 16.1418 11.1254 15.975L17.0252 10.0998C17.192 9.93336 17.2712 9.73336 17.2628 9.49976C17.2544 9.26656 17.1668 9.06656 17 8.89976C16.8336 8.73336 16.6294 8.65016 16.3874 8.65016C16.1458 8.65016 15.9418 8.73336 15.7754 8.89976L10.55 14.1252ZM12.0002 22.0002C10.6002 22.0002 9.2918 21.7418 8.075 21.225C6.8586 20.7082 5.8004 19.9998 4.9004 19.0998C4.0004 18.1998 3.292 17.1416 2.7752 15.9252C2.2584 14.7084 2 13.4 2 12C2 10.6 2.2584 9.29156 2.7752 8.07476C3.292 6.85836 4.0004 5.80016 4.9004 4.90016C5.8004 4.00016 6.8586 3.29176 8.075 2.77496C9.2918 2.25816 10.6002 1.99976 12.0002 1.99976C13.4002 1.99976 14.7086 2.25816 15.9254 2.77496C17.1418 3.29176 18.2 4.00016 19.1 4.90016C20 5.80016 20.7084 6.85836 21.2252 8.07476C21.742 9.29156 22.0004 10.6 22.0004 12C22.0004 13.4 21.742 14.7084 21.2252 15.9252C20.7084 17.1416 20 18.1998 19.1 19.0998C18.2 19.9998 17.1418 20.7082 15.9254 21.225C14.7086 21.7418 13.4002 22.0002 12.0002 22.0002ZM12.0002 20.325C14.3502 20.325 16.3252 19.525 17.9252 17.925C19.5252 16.325 20.3252 14.35 20.3252 12C20.3252 9.64996 19.5252 7.67496 17.9252 6.07496C16.3252 4.47496 14.3502 3.67496 12.0002 3.67496C9.6502 3.67496 7.6752 4.47496 6.0752 6.07496C4.4752 7.67496 3.6752 9.64996 3.6752 12C3.6752 14.35 4.4752 16.325 6.0752 17.925C7.6752 19.525 9.6502 20.325 12.0002 20.325Z",
    fill: "#1D8158"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCopiedIcon);
export default __webpack_public_path__ + "static/media/check-copied-icon.50beaff01206ab3db8a94276c85485aa.svg";
export { ForwardRef as ReactComponent };